import { render } from "./projectsView.vue?vue&type=template&id=8e4283fe&scoped=true"
import script from "./projectsView.vue?vue&type=script&lang=js"
export * from "./projectsView.vue?vue&type=script&lang=js"

import "./projectsView.vue?vue&type=style&index=0&id=8e4283fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4283fe"]])

export default __exports__